import {useMutation, useQueryClient} from '@tanstack/react-query'
import {B2BMetricsRepository} from '../repositories/B2BMetricsRepository.ts'
import {AuthenticationRepository} from '../repositories/AuthenticationRepository.ts'
import {SetTripbookFeedbackPayload} from '../domain/entities/TripbookFeedback.ts'

const b2bMetricsRepository = new B2BMetricsRepository(new AuthenticationRepository())

export function useTripbookFeedback(agencyId: string) {
    const queryClient = useQueryClient()

    const invalidate = () => {
        queryClient.invalidateQueries({queryKey: ['b2b-pack-detail', agencyId]})
        queryClient.invalidateQueries({queryKey: ['b2b-agency-activity', agencyId]})
    }

    const setMutation = useMutation({
        mutationFn: ({tripId, tripbookId, payload}: {tripId: string; tripbookId: string; payload: SetTripbookFeedbackPayload}) =>
            b2bMetricsRepository.setTripbookFeedback(tripId, tripbookId, payload),
        onSuccess: invalidate,
    })

    const deleteMutation = useMutation({
        mutationFn: ({tripId, tripbookId}: {tripId: string; tripbookId: string}) =>
            b2bMetricsRepository.deleteTripbookFeedback(tripId, tripbookId),
        onSuccess: invalidate,
    })

    return {
        setTripbookFeedback: setMutation.mutateAsync,
        isSettingTripbookFeedback: setMutation.isPending,
        deleteTripbookFeedback: deleteMutation.mutateAsync,
        isDeletingTripbookFeedback: deleteMutation.isPending,
    }
}
